/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArchiveEmail = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 3v18H2V3zm-2 2h-7v6.586l2.293-2.293 1.414 1.414L12 15.414l-4.707-4.707 1.414-1.414L11 11.586V5H4v14h16z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArchiveEmail as ArchiveEmail };
